import * as Tooltip from '@radix-ui/react-tooltip';

export default function TooltipInfo({ text, children }) {
  return (
    <Tooltip.Provider>
      <Tooltip.Root delayDuration={0}>
        <Tooltip.Trigger asChild>
          {children}
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            side="top"
            align="center"
            sideOffset={5}
            className="z-[999] rounded bg-black px-2 py-1 text-white text-[10px] shadow-sm max-w-xs break-words"
          >
            {text}
            <Tooltip.Arrow className="fill-black" />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
